export default "00465b695febdd25.svg"